import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../auth";

export const PendingPhotos = ({ onChange }) => {
  const [items, setItems] = useState([]);
  const load = () => axios.get(`${API}/admin/avatars/pending`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const review = async (u, approve) => {
    await axios.post(`${API}/admin/avatars/${u.id}/review?approve=${approve}`);
    load(); onChange?.();
  };
  if (!items.length) return null;
  return (
    <div className="arc-card p-6 mb-6" style={{ borderTop: "5px solid #FFBE0B" }} data-testid="pending-photos">
      <h3 className="font-fredoka font-bold text-lg text-arc-text mb-1">📷 Fotos aguardando aprovação ({items.length})</h3>
      <p className="text-xs text-arc-muted mb-4">A nova foto só aparece no perfil depois que você aprovar.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((u) => (
          <div key={u.id} className="p-4 rounded-2xl bg-arc" data-testid={`pending-photo-${u.id}`}>
            <div className="flex items-center gap-3">
              <img src={u.avatar} alt="atual" className="w-12 h-12 rounded-full bg-white object-cover opacity-60" />
              <span className="text-arc-muted">→</span>
              <img src={u.pending_avatar} alt="nova" className="w-16 h-16 rounded-full bg-white object-cover border-4 border-white shadow" />
              <div className="min-w-0">
                <div className="text-sm font-semibold text-arc-text truncate">{u.name}</div>
                <div className="text-xs text-arc-muted truncate">{u.email}</div>
              </div>
            </div>
            <div className="flex gap-2 mt-3">
              <button onClick={() => review(u, true)} data-testid={`approve-photo-${u.id}`} className="arc-btn arc-btn-primary flex-1 py-2 text-sm">Aprovar</button>
              <button onClick={() => review(u, false)} data-testid={`reject-photo-${u.id}`} className="arc-btn arc-btn-outline flex-1 py-2 text-sm">Recusar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
